import styled from 'styled-components';

export const PaginationStyles = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 16px;

  && {
    .ant-pagination {
      .ant-pagination-item {
        background: var(--wl-background) !important;
        color: var(--wl-on-background) !important;
        border-color: var(--wl-on-background) !important;

        a {
          color: var(--wl-on-background) !important;
        }

        &.ant-pagination-item-active,
        &:hover {
          background: var(--wl-on-background) !important;
          border-color: var(--wl-on-background) !important;

          a {
            color: var(--wl-background) !important;
          }
        }
      }

      .ant-pagination-prev,
      .ant-pagination-next {
        .ant-pagination-item-link {
          color: var(--wl-on-background) !important;
          transition: all 0.2s ease;

          &:hover {
            background: var(--wl-on-background) !important;
            color: var(--wl-background) !important;
          }
        }

        &.ant-pagination-disabled .ant-pagination-item-link {
          color: var(--wl-secondary) !important;
          opacity: 0.5;
          cursor: not-allowed;
        }
      }

      .ant-pagination-jump-next,
      .ant-pagination-jump-prev {
        .ant-pagination-item-link {
          background: var(--wl-background) !important;
          color: var(--wl-on-background) !important;

          &:hover {
            background: var(--wl-on-background) !important;
            color: var(--wl-background) !important;
          }
        }
      }

      .ant-pagination-item-ellipsis {
        color: var(--wl-on-background) !important;
        opacity: 0.7;
        transition: opacity 0.2s ease;

        &:hover {
          opacity: 1;
          color: var(--wl-on-background) !important;
        }
      }
    }
  }
`;
